import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const renewalsConfigApi = createApi({
  reducerPath: 'renewalsConfigApi',
  baseQuery: createBaseQuery('renewals_config', { timeout: 200000 }),
  endpoints: builder => ({
    getRenewalConfigs: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
    }),
    createRenewalConfig: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
    }),
    updateRenewalConfig: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteRenewalConfig: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetRenewalConfigsQuery,
  useCreateRenewalConfigMutation,
  useUpdateRenewalConfigMutation,
  useDeleteRenewalConfigMutation,
} = renewalsConfigApi;
